<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <h3 class="icon pt10 pb10 tar pr15 fs16">
        <v-icon-close @click.native="close"></v-icon-close>
      </h3>
      <div class="flex flex-center-2 pb20">
        <ul class="relative">
          <div class="absolute line bg_main"></div>
          <li class="flex flex-center relative" v-for="(s,i) in steps" :key="i" :class="{mt20:i,active:i==active}">
            <div class="icon">{{ i + 1 }}</div>
            <div class="label color_666 ml10">{{ s.label }} {{ s.date }}</div>
          </li>
        </ul>
      </div>
      <p class="color_999 tac pb30">具体手术情况以院内通知为准！</p>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";
import VIconClose from "@/plugins/v-icon-close";

const handlerDate = str => {
  if (!str || str.length !== 19) {
    return str
  }
  return str.substr(5, 11);
}

export default {
  name: "confirm",
  components: {VIconClose, VTabs},
  data() {
    return {
      old: [
        {label: '入手术室', id: 'jSSSSJ'},
        {
          label: '麻醉开始',
          id: 'mZKSSJ'
        }, {label: '手术开始', id: 'kSSJ'},
        {label: '手术结束', id: 'jSSJ'},
        {label: '麻醉结束', id: "mZJSSJ"},
        {
          label: '出手术室',
          id: "cSSSSJ"
        }],
      title: "",
      state: {},
      type: '',
      showTag: false
    }
  },
  computed: {
    steps() {
      let old = [...this.old];
      const jFSSSJ = {label: '进复苏室', id: 'jFSSSJ'};
      const cFSSSJ = {label: '出复苏室', id: 'cFSSSJ'};
      console.log('old', old, {...this.state});
      if (this.state.jFSSSJ)
        old.push(jFSSSJ)
      if (this.state.cFSSSJ)
        old.push(cFSSSJ)
      return old.map(r => {
        return {
          ...r,
          date: handlerDate(this.state[r.id])
        }
      })
    },
    active() {
      let idx = -1;
      for (let i = 0; i < this.steps.length; i++) {
        if (this.steps[i].date) {
          idx = i;
        }
      }
      return idx >= 0 ? idx : 0;
    }
  },
  methods: {
    open() {
      this.showTag = true;
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../common/public";

li {
  .icon {
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #d8e7fe;
    border-radius: 50%;
    color: $mainColor;
  }
}

.active {
  .label {
    color: $mainColor;
  }

  .icon {
    background-color: $mainColor;
    color: white;
  }
}

.line {
  left: 12px;
  top: 12px;
  bottom: 12px;
  width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ds-show-shoushu.vue